export default "__VITE_ASSET__bGt2l_8r__"